import { FabExposed } from '@/utils/fab-wb/types';

export const createFab = (): FabExposed => window.fab;
